var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.02261 12.8H12.4226C12.5926 12.8 12.7351 12.8575 12.8501 12.9725C12.9651 13.0875 13.0226 13.23 13.0226 13.4C13.0226 13.57 12.9651 13.7125 12.8501 13.8275C12.7351 13.9425 12.5926 14 12.4226 14H4.02261C3.85261 14 3.71011 13.9425 3.59511 13.8275C3.48011 13.7125 3.42261 13.57 3.42261 13.4C3.42261 13.23 3.48011 13.0875 3.59511 12.9725C3.71011 12.8575 3.85261 12.8 4.02261 12.8ZM8.22261 11.225C8.13261 11.225 8.04511 11.205 7.96011 11.165C7.87511 11.125 7.80261 11.065 7.74261 10.985L4.77261 7.175C4.62261 6.975 4.60261 6.7625 4.71261 6.5375C4.82261 6.3125 5.00261 6.2 5.25261 6.2H6.42261V2.6C6.42261 2.43 6.48011 2.2875 6.59511 2.1725C6.71011 2.0575 6.85261 2 7.02261 2H9.42261C9.59261 2 9.73511 2.0575 9.85011 2.1725C9.96511 2.2875 10.0226 2.43 10.0226 2.6V6.2H11.1926C11.4426 6.2 11.6226 6.3125 11.7326 6.5375C11.8426 6.7625 11.8226 6.975 11.6726 7.175L8.70261 10.985C8.64261 11.065 8.57011 11.125 8.48511 11.165C8.40011 11.205 8.31261 11.225 8.22261 11.225Z",
    fill: "#003DA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.f56e964eca531868088538124b711520.svg";
export { ForwardRef as ReactComponent };